export default "/static/dashboard/build/app/img/v2/f43bd901672b8ffb9cb1c4c84fe68753.png";